import React from "react";

export default function Card({ title, right, children }) {
  return (
    <div
      style={{
        background: "var(--card, #ffffff)",
        border: "1px solid rgba(15,23,42,0.088)",
        borderRadius: 16,
        padding: 14,
        boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline" }}>
        <div style={{ fontSize: 12, opacity: 0.8 }}>{title}</div>
        {right}
      </div>
      <div style={{ marginTop: 12 }}>{children}</div>
    </div>
  );
}
